import PropTypes from 'prop-types';
import React from 'react';
import FlexBox from 'flexbox-react';
import { Input } from 'react-toolbox';
import DatePicker from 'components/DatePicker';
import BreakLine from 'components/BreakLine';
import { can } from '../../../../../services';
import styles from 'styles/form';
import { error } from '../../../../../utils';

const largeInput = `${styles.inputs} ${styles.largeInput}`;

const InstallerCertificationsForm = ({ installer, onChange, role, errors }) => {
  const canEdit = can(role, 'update', 'installer');
  const onFirmNumber = e => onChange('installer_firm_certification_number', e);
  const onFirmExpiration = v => onChange('installer_firm_certification_expiration', v);
  const onRenovatorNumber = e => onChange('assigned_renovator_certification_number', e);
  const onRenovatorExpiration = v => onChange('assigned_renovator_certification_expiration', v);

  return (
    <div>
      <FlexBox flexWrap="wrap" className={styles.divider}>
        <p className={styles.cardSubtitle}>
          Firm and assigned renovator certification numbers and expirations.
          These values are used when generating IFI paperwork.
        </p>
        <BreakLine />
        <Input
          label="Installer firm certification number"
          className={largeInput}
          value={installer.installer_firm_certification_number || ''}
          onChange={onFirmNumber}
          error={error('installer_firm_certification_number', errors)}
          disabled={!canEdit}
        />
        <DatePicker
          label="Installer firm certification expiration"
          className={largeInput}
          value={installer.installer_firm_certification_expiration}
          onChange={onFirmExpiration}
          error={error('installer_firm_certification_expiration', errors)}
          disabled={!canEdit}
        />
        <BreakLine />
        <Input
          label="Assigned renovator certification number"
          className={largeInput}
          value={installer.assigned_renovator_certification_number || ''}
          onChange={onRenovatorNumber}
          error={error('assigned_renovator_certification_number', errors)}
          disabled={!canEdit}
        />
        <DatePicker
          label="Assigned renovator certification expiration"
          className={largeInput}
          value={installer.assigned_renovator_certification_expiration}
          onChange={onRenovatorExpiration}
          error={error('assigned_renovator_certification_expiration', errors)}
          disabled={!canEdit}
        />
      </FlexBox>
    </div>
  );
};

InstallerCertificationsForm.propTypes = {
  installer: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  errors: PropTypes.object,
};

InstallerCertificationsForm.defaultProps = {
  errors: {},
};

export default InstallerCertificationsForm;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/installerCertificationsForm.jsx